import axios from './axios'

function service(endpoint) {

    function fetchStatistics() {
        return axios.get(endpoint).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchStatistics
    }
}

export default service
